import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import { push } from 'react-router-redux';

// Styles
import styles from './styles';

// Material UI
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class Start extends Component {
  render(){
    const { classes, theme, location } = this.props;
    return(
      <div className={classes.root}>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          The account section of the DSN App lets you keep up to date with all your account and service levels. Just tap one of the options below to get started.
        </Typography>
        <br/>
        <Typography type="sub-heading" color="inherit" className={classes.text}>
          Customer Information Goes Here.
        </Typography>
      </div>
    );
  }
}
/*
<Button onClick={() => {this.props.changeRoute("/console/profile/service_level");}} className={classes.button} raised color="primary">
  Upgrade Service Level
</Button>
<Button onClick={() => {this.props.changeRoute("/console/profile/account_login");}} className={classes.button} raised color="primary">
  Account and Login
</Button>
*/

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number, 
        project_id: state.prefix.project_id,
    };
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    changeRoute: (url) => dispatch(push(url)),
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(Start)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Account/scenes/Start/index.js